import axios from '../axiosConfig'
import { tokenConfig } from './auth'

import {
  FLUSH_DTO_MANUAL,
  FLUSH_PRECIO_MANUAL,
  GET_PRECIOS_PERMISOS_FAIL,
  GET_PRECIOS_PERMISOS_SUCCESS,
  SET_DTO_MANUAL,
  SET_PRECIO_MANUAL,
} from './types'

let body

export const getPrecioYPermisos =
  (codigo_articulo, cantidad_pedida = 1, domicilio_envio = '', presentacion = '', origen = '') =>
  (dispatch) => {
    let articulos_cantidades = [
      {
        codigo_articulo: codigo_articulo,
        cantidad: cantidad_pedida,
        presentacion: presentacion,
      },
    ]

    dispatch(getPreciosYPermisos(articulos_cantidades, origen, domicilio_envio))
  }

export const getPreciosYPermisos =
  (articulos_cantidades = [], origen = '', domicilio_envio = '', maximo_agrupados = 36) =>
  (dispatch, getState) => {
    //Comprobamos si supera el maximo

    if (articulos_cantidades.length > Number(maximo_agrupados)) {
      let z = 0 //Indice del array de arrays
      let array_aux = [] //Declaramos un array auxiliar
      array_aux[z] = [] //Lo iniciamos como array de arrays

      for (let x = 0; x < articulos_cantidades.length; x++) {
        //Hacemos push del valor actual
        array_aux[z].push({
          codigo_articulo: articulos_cantidades[x].codigo_articulo,
          cantidad: articulos_cantidades[x].cantidad,
          presentacion: articulos_cantidades[x].presentacion,
        })

        //Si x es divisor entero del maximo (sin ser 0 o 1)
        if (
          x !== 0 &&
          x !== 1 &&
          (x + 1) % Number(maximo_agrupados) === 0 &&
          x + 1 !== articulos_cantidades.length
        ) {
          z++ //Aumentamos el indice
          array_aux[z] = [] //Iniciamos el siguiente valor
        }
      }
      z = 0
      //Lanzamos peticion de precios variable del array de arrays
      array_aux.forEach(array_articulos => {
        body = JSON.stringify({
          articulos_cantidades: array_articulos,
          domicilio_envio,
        })
        z++

        axios
          .post(`/articulos/preciosValoracion?origen=${origen}`, body, tokenConfig(getState))
          .then(res => {
            dispatch({
              type: GET_PRECIOS_PERMISOS_SUCCESS,
              articulos_cantidades: array_articulos,
              payload: res.data,
            })
          })
          .catch(err => {
            dispatch({
              type: GET_PRECIOS_PERMISOS_FAIL,
              articulos_cantidades: array_articulos,
            })
          })
      })
    } else {
      //Si no supera el maximo se lanza una unica peticion
      body = JSON.stringify({
        articulos_cantidades,
        domicilio_envio,
      })

      axios
        .post(`/articulos/preciosValoracion?origen=${origen}`, body, tokenConfig(getState))
        .then(res => {
          dispatch({
            type: GET_PRECIOS_PERMISOS_SUCCESS,
            articulos_cantidades: articulos_cantidades,
            payload: res.data,
          })
        })
        .catch(err => {
          dispatch({
            type: GET_PRECIOS_PERMISOS_FAIL,
            articulos_cantidades: articulos_cantidades,
          })
        })
    }
  }

export const setPrecioManual = (codigo_articulo, nuevo_precio, presentacion) => dispatch => {
  dispatch({
    type: SET_PRECIO_MANUAL,
    codigo_articulo: codigo_articulo,
    nuevo_precio: nuevo_precio,
    presentacion: presentacion,
  })
}

export const setDtoManual = (codigo_articulo, nuevo_dto, presentacion) => dispatch => {
  dispatch({
    type: SET_DTO_MANUAL,
    codigo_articulo: codigo_articulo,
    nuevo_dto: nuevo_dto,
    presentacion: presentacion,
  })
}

export const limpiarPrecioManual = (codigo_articulo, presentacion) => dispatch => {
  dispatch({
    type: FLUSH_PRECIO_MANUAL,
    codigo_articulo: codigo_articulo,
    presentacion: presentacion,
  })
}

export const limpiarDtoManual = (codigo_articulo, presentacion) => dispatch => {
  dispatch({
    type: FLUSH_DTO_MANUAL,
    codigo_articulo: codigo_articulo,
    presentacion: presentacion,
  })
}
